export const { useDispatch, useSelector, Provider } = WPTB.modules.ReactRedux;
